<form #form="ngForm">
    <ng-container *ngIf="role">
        <ng-container *ngIf="!role.id && showSetup">
            <div class="ui three column grid">
                <div class="column">
                    <ui-card variant="outline" [clickable]="true" (click)="newRole('admin')">
                        <h3 class="roleType">
                            {{ 'settings.role-create-form.administratorButton' | translate }}
                        </h3></ui-card
                    >
                </div>
                <div class="column">
                    <ui-card variant="outline" [clickable]="true" (click)="newRole('manager')">
                        <h3 class="roleType">{{ 'settings.role-create-form.managerButton' | translate }}</h3>
                    </ui-card>
                </div>
                <div class="column">
                    <ui-card variant="outline" [clickable]="true" (click)="newRole('employee')"
                        ><h3 class="roleType">{{ 'settings.role-create-form.employeeButton' | translate }}</h3></ui-card
                    >
                </div>
            </div>
            <br />
            <div class="ui horizontal divider">{{ 'settings.role-create-form.or' | translate }}</div>
            <br />
            <a (click)="newRole('scratch')">
                {{ 'settings.role-create-form.createCustomRoleFromScratchLabel' | translate }}
            </a>
            <br />
        </ng-container>

        <ng-container *ngIf="!showSetup">
            <div class="app-grid">
                <mat-form-field class="columns-12">
                    <mat-label>{{ 'settings.role-create-form.nameLabel' | translate }}</mat-label>
                    <input
                        type="text"
                        name="name"
                        required
                        #name="ngModel"
                        [(ngModel)]="role.name"
                        placeholder="{{ 'settings.role-create-form.namePlaceholder' | translate }}"
                        matInput
                    />
                    <mat-error *ngIf="name.invalid">{{ name.errors | formErrors }}</mat-error>
                </mat-form-field>

                <mat-form-field class="columns-12">
                    <mat-label>{{ 'settings.role-create-form.descriptionLabel' | translate }}</mat-label>
                    <textarea
                        required
                        #description="ngModel"
                        name="description"
                        [(ngModel)]="role.description"
                        rows="10"
                        matInput
                    ></textarea>
                    <mat-error *ngIf="description.invalid">{{ description.errors | formErrors }}</mat-error>
                </mat-form-field>
            </div>
        </ng-container>
    </ng-container>
</form>
